import axios from 'axios';
import { clearObject, getToken } from '../utils';

const apiGateway = axios.create({
    baseURL: process.env.REACT_APP_API_GATEWAY_URL, // url da API
    timeout: process.env.REACT_APP_API_TIMEOUT,
    headers: {
        'Cache-Control': 'no-cache',
    },
});

apiGateway.interceptors.request.use(
    (config) => {
        const body = config.data;

        if (body) config.data = clearObject(body);

        // Enviando Token do B2C como Authorization
        config.headers.Authorization = `Bearer ${getToken()}`;

        // Header customizado com o contrato selecionado
        const contratoAtivoSession = sessionStorage.getItem('numeroContratoAtivo');
        if (contratoAtivoSession) config.headers['gndi-ct'] = contratoAtivoSession;

        if (process.env.PUBLIC_URL === '/empresa_qa2') {
            delete config.headers['gndi-ct'];
            config.headers.Authorization = 'Basic bm92b3BvcnRhbDo2ODIxM2JlMGE4M2IzZTcxMTkwY2JhOGZiZGZiYTkyYg==';
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export { apiGateway };
